import React, { useEffect, useState, useRef } from "react";
import { useToast } from "../../controller/ToastController";
import { useRecoilState } from "recoil";
import { comfirmModalState, ModalType } from "../../recoil/confirm";
import LandingController, {
  ContactType,
} from "../../controller/landingController";
import styled from "styled-components";

const ContactPage = () => {
  const showToast = useToast();
  const [storeName, setStoreName] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [hour, setHour] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [sector, setSector] = useState<string>("");
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);

  const submitContactUs = async () => {
    if (storeName === "") {
      showToast("매장명을 입력해주세요.", "error");
    } else if (phoneNumber === "") {
      showToast("전화번호를 입력해주세요.", "error");
    } else if (hour === "") {
      showToast("통화가능시간을 입력해주세요.", "error");
    } else if (address === "") {
      showToast("주소를 입력해주세요.", "error");
    } else if (sector === "") {
      showToast("업종을 입력해주세요.", "error");
    } else {
      setIsSubmitDisable(true);
      try {
        const contactList: ContactType = {
          store_name: storeName,
          phone_number: phoneNumber,
          hour: hour,
          address: address,
          sectors: sector,
        };
        const oRes = await LandingController.setContactUs(contactList);

        console.log("oRes", oRes);
        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          if (oResponse.ok) {
            showToast(
              "상담신청이 완료되었습니다. 영업일 1-2일 내에 연락드리겠습니다.",
              "success",
              5000
            );
            setTimeout(() => {
              window.location.reload();
            }, 5000);
          }
        }
      } catch (err) {
        console.log("err---->", err);
      } finally {
        setIsSubmitDisable(false);
      }
    }
  };

  return (
    <Style>
      <div className="contactWrap">
        <h1>상담 신청하기</h1>
        <h2>상담을 위한 정보를 남겨주시면 빠르게 도와드릴게요</h2>
        <div className="inputWrap">
          <div className="inputContent">
            <h3>매장명</h3>
            <input
              type="text"
              value={storeName}
              onChange={(e) => setStoreName(e.target.value)}
              placeholder="매장명을 입력해주세요  예) OO치킨OO점"
            />
          </div>
          <div className="flexContent">
            <div className="inputContent">
              <h3>전화번호</h3>

              <input
                type="number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="전화번호를 입력해주세요"
              />
            </div>
            <div className="inputContent">
              <h3>통화 가능 시간</h3>
              <input
                type="text"
                value={hour}
                onChange={(e) => setHour(e.target.value)}
                placeholder="전화 가능한 시간대를 입력해주세요"
              />
            </div>
          </div>
          <div className="inputContent">
            <h3>주소</h3>
            <input
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="주소를 입력해주세요"
            />
          </div>
          <div className="inputContent">
            <h3>업종</h3>
            <input
              type="text"
              value={sector}
              onChange={(e) => setSector(e.target.value)}
              placeholder="업종을 입력해주세요  예)카페"
            />
          </div>
        </div>
        <button
          onClick={submitContactUs}
          disabled={isSubmitDisable}
          className="submitButton"
        >
          신청하기
        </button>
      </div>
    </Style>
  );
};

export default ContactPage;
const Style = styled.div`
  h1 {
    margin-bottom: 30px;
    font-size: 44px;
    font-weight: 500;
    color: #555;
  }
  h2 {
    font-size: 24px;
    font-weight: 500;
    color: #979797;
  }
  h3 {
    font-size: 20px;
    font-weight: 500;
    color: #979797;
  }

  .contactWrap {
    width: 100%;
    padding: 200px 30% 100px 30%;
    text-align: center;
  }
  .inputWrap {
    margin: 130px 0;

    .inputContent {
      margin-bottom: 27px;
      text-align: left;

      input {
        width: 100%;
        margin-top: 6px;
        padding: 11px;
        border: 1px solid #cecece;
        border-radius: 5px;
        font-size: 16px;
        font-weight: 400;
      }
      input::placeholder {
        color: #cecece;
      }
    }
  }
  .flexContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 21px;

    .inputContent {
      flex: 1;
    }
  }
  .submitButton {
    padding: 21px 150px;
    font-size: 32px;
    font-weight: 600;
    color: #fff;
    background: #333333;
    box-shadow: 4px 4px 4px 0px #00000040;
    border-radius: 80px;
  }

  @media (max-width: 1300px) {
    .contactWrap {
      padding: 0 20%;
    }
  }
  @media (max-width: 1100px) {
    h1 {
      margin-bottom: 10px;
      font-size: 24px;
    }
    h2 {
      font-size: 14px;
    }
    h3 {
      font-size: 16px;
    }

    .contactWrap {
      padding: 100px 3vw;
    }
    .inputWrap {
      margin: 40px 0;
    }
    .flexContent {
      flex-direction: column;
      gap: 0;

      .inputContent {
        width: 100%;
      }
    }
    .submitButton {
      width: 100%;
      padding: 14px;
      font-size: 20px;
    }
  }
`;
